import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SubCategoryDTO,CategoryDTO, ColorDTO, SizeDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class colorService implements OnInit {
    public Source:LocalDataSource;

    constructor(private http: HttpClient,private notifcationService:NotificationService) {
        this.Source = new LocalDataSource();
    }

    getColors():any{
       return this.http.get<ColorDTO[]>(environment.apiUrl + "/Color/GetColors")
       .pipe(
        catchError(this.handleError)
       );
    }

    getColorStatus(codeproduct: string): any {
        return this.http.get<boolean>(environment.apiUrl + "/product/isColorenabled/" + codeproduct)
            .pipe(
                catchError(this.handleError)
            );
    }

    
    getSize():any{
        return this.http.get<SizeDTO[]>(environment.apiUrl + "/Size")
        .pipe(
         catchError(this.handleError)
        );
    }
     

    addColor(colorDTO:ColorDTO){
        return this.http.post(environment.apiUrl + "/Color", colorDTO).subscribe(
            data => {
                this.notifcationService.showSuccess("Color", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Color", "ajout avec success");
                console.error(error);
            }
        );
    }

    addSize(sizeDTO:SizeDTO){
        return this.http.post(environment.apiUrl + "/Size", sizeDTO).subscribe(
            data => {
                this.notifcationService.showSuccess("Size", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Size", "ajout avec success");
                console.error(error);
            }
        );
    }

    updateColor(Color: ColorDTO) {

        return this.http.put(environment.apiUrl + "/Color", Color).subscribe(
            data => {
                this.notifcationService.showSuccess("Color", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Color", "ajout avec success");
                console.error(error);
            }
        );

    }

    

    deleteColor(idColor:number){
        this.http.delete<any>(environment.apiUrl + "/Color/"+idColor).subscribe(
            data => {
                this.notifcationService.showSuccess("Color", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Color", "suppression avec success");
                console.error(error);
            }
        );
    }

    deleteSize(idSize:number){
        this.http.delete<any>(environment.apiUrl + "/Size/"+idSize).subscribe(
            data => {
                this.notifcationService.showSuccess("Size", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Size", "suppression avec success");
                console.error(error);
            }
        );
    }



    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
      };



}